module.exports = __webpack_public_path__ + "img/w42b.76f3aebb.jpg";